export default {
  en: {
    every: 'Every',
    everyDayOfWeek: 'every day of the week',
    everyDayOfMonth: 'every day of the month',
    everyMonth: 'every month',
    everyDropdown: 'every',
    periodOptions: ['minute', 'hour', 'day', 'week', 'month', 'year'],
    daysOfWeek: [
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday',
      'sunday',
    ],
    months: [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ],
    on: 'on',
    of: 'of',
    at: 'at',
    minuteFieldLabel: 'minutes(s)',
    minutesPastTheHour: 'minute(s) past the hour',
    inTimezone: 'in timezone',
    selectMinutes: 'select',
    hour: 'hour',
    hours: 'hours',
    minute: 'minute',
    minutes: 'minutes',
    multiSelectHelp: 'Hold CTRL or SHIFT for selecting multiple values.',
    multiSelectHelpMac: 'Hold COMMAND or SHIFT for selecting multiple values.',
    validation: {
      selectMinutes: 'Select minutes',
      provideValidValues: 'Provide valid values',
      validMinutes: 'Minutes must be between 1 and 60',
    },
  },
};
